import { API } from '../../shared/constants/constants';
import { stopRefreshTokenTimer } from './refreshToken';
import { stopCloudfrontRefreshTimer } from '../../shared/functions/refreshCloudfrontCookies';

export function clearAuthStorage() {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.clear();
    window.sessionStorage.clear();
  } catch (error) {
    console.warn('Failed to clear web storage during logout', error);
  }
}

export function runLogoutCleanup() {
  stopRefreshTokenTimer();
  stopCloudfrontRefreshTimer();
  clearAuthStorage();
}

export default function logout(_username, callback) {
  return API.post('/user/logout')
    .catch((error) => {
      console.error('Logout request failed', error);
    })
    .finally(() => {
      runLogoutCleanup();

      if (typeof callback === 'function') {
        callback();
      }
    });
}
